<!--    @if (dataSource) {-->
<!--      <input (keyup)="applyFilter($event.target.value)" placeholder="Search events"/>-->
<!--    }-->

<!--    &lt;!&ndash;TODO style the paginator to match the site&ndash;&gt;-->
<!--    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200]" [pageSize]="10"-->
<!--                   length="{{tableData ? tableData.length : 0}}" showFirstLastButtons></mat-paginator>-->
<style>
  .highlighted, .highlighted td {
  background: #c2b49b !important;
}
</style>
<div class="table-container" style="overflow:unset;">
  @if (dataSource!==undefined) {
    <table [dataSource]="dataSource" [matSortActive]="columns[0]"
      class="value-driver-tree-table" mat-table
      matSort matSortDirection="asc">
      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column">
          <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
            <ng-container>{{column | upperfirst}}</ng-container>
          </th>
          <td *matCellDef="let element;" [ngClass]="{'highlighted': element['index']==highlight_index}" mat-cell>
            @if (column === 'name') {
              <div class="row auto center">
                <i (click)="editSeries(element)" class="edit-inline hide-xs"></i>
                <a (click)="openChartDialog(element[column])" [textContent]="element[column]" style="cursor:pointer;"></a>
              </div>
            }
            @if (!['name', 'parent','depth'].includes(column)) {
              <div [ngClass]="{'justify-center': column === 'depth'}"
                class="row auto center">{{element[column]}}
              </div>
            }
            @if (column === 'depth') {
              <div class="column center">
                @for (depth of element[column]; track $index; let i = $index) {
                  <div (mouseenter)="highlight(element, i);" (mouseleave)="highlight_index = null;"
                    >
                    <span>{{depth}}</span>
                  </div>
                }
              </div>
            }
            @if (column === 'parent') {
              <div class="column center">
                @for (parent of element[column]; track $index; let i = $index) {
                  <div (mouseenter)="highlight(element, i);" (mouseleave)="highlight_index = null;"
                    >
                    <span>{{parent}}</span>
                  </div>
                }
              </div>
            }
          </td>
        </ng-container>
      }
      <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: columns;" mat-row></tr>
    </table>
  }
</div>
